import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListDeviceLoginDenial } from '../../../../../api-new/state/auth'
import { ColumnDateTime, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { IconAuthLogin } from '../../../../../shared/icon/icon'

// Every refused device sign-in, newest first.
//
// Reason is the column that matters and is deliberately not hidden: only
// "explicit" means someone was shown the request and refused it. "dismissed"
// means they closed the screen, which people do for all sorts of reasons, and
// "unspecified" comes from clients too old to say. Reading a case without that
// distinction would build an argument out of distracted approvers.
export const DeviceLoginDenialList = () => {
  const apiList = useApiListDeviceLoginDenial()

  const handleReady = async () => await apiList.get()
  const handleDestroyed = () => apiList.init()

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconAuthLogin} text="Refused device sign-ins">
        <CardFullHeightScrollY title="refused device sign-ins">
          <TableAgClient
            apiList={apiList}
            onReady={handleReady}
            onDestoryed={handleDestroyed}
            emptyState={{ Icon: IconAuthLogin, title: 'No refused sign-ins', message: 'Sign-ins refused by an organization\'s sign-in rules appear here.' }}>
            <ColumnDateTime field="createdAt" header="When" />
            <ColumnText field="reason" header="Reason" />
            <ColumnText field="code" header="Code" />
            <ColumnText field="ipAddress" header="Requester IP" />
            <ColumnText field="ipLocation" header="Requester location" />
            <ColumnText field="clientInfo" header="Requester device" />
            <ColumnText field="deniedByLoginID" header="Refused by (login)" />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
